import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const exportCampaign = (tokens: any, reqBody: any) => {
  const config: any = sitConfig(tokens)
  const request: Request<{}> = {
    config: config,
    apiPath: `${sitConfig(tokens).baseUrl}${APIEndPoints.exportCampaign}`,
    method: 'POST',
    responseType: 'arraybuffer',
    body: reqBody,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })

  // return axios
  //   .post(`${sitConfig(tokens).baseUrl}${APIEndPoints.exportCampaign}`, reqBody, {
  //     headers: sitConfig(tokens).headers,
  //     responseType: 'arraybuffer', //DO NOT change this it will download empty file and break session expire
  //   })
  //   .then((resp) => {
  //     return responseParser(resp)
  //   })
}

export { exportCampaign }
